import { environment } from '../../environment';

// Organizations

export const ORGANIZATIONS_YGGDRASIL_BASE_PATH = `${environment.visionizeApiUrl ?? 'https://api.dev-lab-suite.visionize.com'}/organizations-v2/organizations`;

export const LOCALHOST_BASE_URL = 'http://localhost:5173';

export const LOCALHOST_GRAPHQL_URL = 'http://localhost:5173';

export const MIGRATION_BASE_PATH = environment.visionizeApiUrl || '';

// biome-ignore lint/suspicious/noExplicitAny: any is used for query params
export function objectToURLSearchParams(obj: Record<string, any>) {
  return new URLSearchParams(obj);
}

export const createPathWithQueryParams = (
  basePath: string,

  // biome-ignore lint/suspicious/noExplicitAny: any is used for query params
  queryParams: Record<string, any>,
) => {
  const stringifiedQueryParams = new URLSearchParams(queryParams).toString();
  return `${basePath}?${stringifiedQueryParams}`;
};
